import { Controller } from "@hotwired/stimulus";

// Shows the recipient block for "Send direct", and the date field for "Choose a date".
export default class extends Controller {
  static targets = ["recipient", "date"];

  declare recipientTarget: HTMLElement;
  declare dateTarget: HTMLElement;
  declare hasRecipientTarget: boolean;
  declare hasDateTarget: boolean;

  connect(): void {
    this.toggleRecipient();
    this.toggleDate();
  }

  toggleRecipient(): void {
    if (!this.hasRecipientTarget) return;

    const sendDirect = this.element.querySelector<HTMLInputElement>(
      'input[name="payment[gift_attributes][delivery_type]"][value="e-card"]'
    );
    this.recipientTarget.classList.toggle("tw-hidden", !sendDirect?.checked);
  }

  toggleDate(): void {
    if (!this.hasDateTarget) return;

    const sendLater = this.element.querySelector<HTMLInputElement>(
      'input[name="gift_recipient[delivery_schedule]"][value="send later"]'
    );
    this.dateTarget.classList.toggle("tw-hidden", !sendLater?.checked);
  }
}
